/**
 * Human labels for the coded reasons an administrator picks (FR-178): unpublish
 * (`UNPUBLISH_REASON_CODES`), image removal (`IMAGE_REMOVAL_REASON_CODES`) and duplicate
 * dismissal (`DUPLICATE_DISMISS_REASONS`) in the backend. The audit log stores the code;
 * this is how it reads back the label the administrator chose from.
 */
export const UNPUBLISH_REASONS = [
  { code: 'partner_request', label: 'Partner asked' },
  { code: 'quality', label: 'Listing quality' },
  { code: 'duplicate', label: 'Duplicate' },
  { code: 'pricing', label: 'Pricing' },
  { code: 'legal', label: 'Legal or compliance' },
  { code: 'other', label: 'Other' },
] as const;

const OTHER_REASON_LABELS: Record<string, string> = {
  wrong_location: 'Wrong location',
  people_or_plates: 'People or number plates',
  not_a_duplicate: 'Not a duplicate',
  same_building_different_unit: 'Same building, different unit',
  partner_confirmed_distinct: 'Partner confirmed distinct',
};

/** The label for a stored reason code; an unknown code is shown as stored. */
export function reasonLabel(code: string): string {
  const unpublish = UNPUBLISH_REASONS.find((reason) => reason.code === code);
  return unpublish?.label ?? OTHER_REASON_LABELS[code] ?? code;
}
